import actions from "../actionTypes/filterTypes";
import Siteactions from "../actionTypes/index";

export const getSiteSelectedClient = payload => ({
  type: actions.SITE_SELECTED_CLIENT,
  payload
});

export const getSiteSelectedStatus = payload => ({
  type: actions.SITE_SELECTED_STATUS,
  payload
});

export const getWorkHistorySelectedStatus = payload => ({
  type: actions.WORK_HISTORY_SELECTED_STATUS,
  payload
});

export const getSiteCandidateType = payload => ({
  type: actions.SELECTED_SITE_CANDIDATE_TYPE,
  payload
});

export const getSiteSelectedPerformance = payload => ({
  type: actions.SITE_SELECTED_PERFORMANCE,
  payload
});

export const getSiteSelectedInfringementType = payload => ({
  type: actions.SITE_SELECTED_INFRINGEMENT_TYPE,
  payload
});

export const getSiteSelectedInfringementStatus = payload => ({
  type: actions.SITE_SELECTED_INFRINGEMENT_STATUS,
  payload
});

export const getSiteSelectedPayment = payload => ({
  type: actions.SITE_SELECTED_PAYMENT,
  payload
});

export const getSiteSelectedBranches = payload => ({
  type: actions.SITE_SELECTED_BRANCHES,
  payload
});

export const getSiteSelectedTags = payload => ({
  type: actions.SITE_SELECTED_TAGS,
  payload
});

export const getSiteSearchKeyword = payload => ({
  type: actions.SITE_SEARCH_KEYWORD,
  payload
});

export const clearSiteSearchKeyword = payload => ({
  type: actions.SITE_SEARCH_KEYWORD_CLEAR,
  payload
});

export const getSiteSelected = payload => ({
  type: actions.SITE_SELECTED,
  payload
});

export const getDayofWeek = () => ({
  type: Siteactions.SITE_DAYS_OF_WEEK
});

export const addGeneralDetails = payload => ({
  type: Siteactions.ADD_SITE_GENERAL_DETAILS,
  payload
});

export const getShiftType = () => ({
  type: Siteactions.SITE_DEFAULT_SHIFT_TYPE
});

export const addContactForm = payload => ({
  type: Siteactions.ADD_SITE_CONTACT_FORM,
  payload
});

export const getSupplierList = () => ({
  type: Siteactions.SITE_SUPPLIER_LIST
});

export const saveAwrDetails = payload => ({
  type: Siteactions.SAVE_AWR_DETAILS,
  payload
});

export const clearSaveAwrDetails = () => ({
  type: Siteactions.SAVE_AWR_DETAILS_CLEAR
});

export const defaultAWRDetails = payload => ({
  type: Siteactions.DEFAULT_AWR_RULE,
  payload
});

export const updateSiteContact = payload => ({
  type: Siteactions.UPDATE_SITE_CONTACT,
  payload
});

export const getGeneralDetails = payload => ({
  type: Siteactions.GET_SITE_DETAILS,
  payload
});

export const updateGeneralDetails = payload => ({
  type: Siteactions.UPDATE_GENERAL_DETAILS,
  payload
});

export const clearUpdateGeneralDetails = () => ({
  type: Siteactions.UPDATE_GENERAL_DETAILS_CLEAR
});

export const addClientShiftTypeData = payload => ({
  type: Siteactions.ADD_CLIENT_SHIFT_TYPE_DATA,
  payload
});

export const handleApprovedSuppliers = payload => ({
  type: Siteactions.APPROVED_SUPPLIERS,
  payload
});

export const updateClientShiftTypeData = payload => ({
  type: Siteactions.UPDATE_CLIENT_SHIFT_TYPE_DATA,
  payload
});

export const deleteClientShiftTypeData = payload => ({
  type: Siteactions.DELETE_CLIENT_SHIFT_TYPE_DATA,
  payload
});

export const getContactDetails = payload => ({
  type: Siteactions.GET_SITE_CONTACT_DETAILS,
  payload
});

export const deleteAWR = payload => ({
  type: Siteactions.DELETE_AWR_RULE,
  payload
});

export const clearDeleteAwr = () => ({
  type: Siteactions.DELETE_AWR_RULE_CLEAR
});

export const copyAWR = payload => ({
  type: Siteactions.COPY_AWR_RULE,
  payload
});

export const clearCopyAwr = () => ({
  type: Siteactions.COPY_AWR_RULE_CLEAR
});

export const saveResourceRequirements = payload => ({
  type: Siteactions.SAVE_RESOURCE_REQUIREMENT,
  payload
});

export const getResourceRequirements = payload => ({
  type: Siteactions.GET_RESOURCE_REQUIREMENT,
  payload
});

export const deleteResourceRequirements = payload => ({
  type: Siteactions.DELETE_RESOURCE_REQUIREMENT,
  payload
});

export const updateResourceRequirements = payload => ({
  type: Siteactions.UPDATE_RESOURCE_REQUIREMENT,
  payload
});

export const getSitePipelineCandidates = payload => ({
  type: Siteactions.GET_PIPELINE_CANDIDATE,
  payload
});

export const getSiteCandidatePerformance = payload => ({
  type: Siteactions.GET_SITE_CANDIDATE_PERFORMANCE,
  payload
});

export const getSiteInfringement = payload => ({
  type: Siteactions.GET_SITE_INFRINGEMENT,
  payload
});

export const getCurrentUserRole = payload => ({
  type: actions.CURRENT_USER_ROLE,
  payload
});

export const clearGetSiteInfringement = () => ({
  type: Siteactions.GET_SITE_INFRINGEMENT_CLEAR
});

export const ClearGetSiteCandidatePerformance = () => ({
  type: Siteactions.GET_SITE_CANDIDATE_PERFORMANCE_CLEAR
});

export const ClearGetResourceRequirements = () => ({
  type: Siteactions.GET_RESOURCE_REQUIREMENT_CLEAR
});

export const ClearGetSitePipelineCandidates = () => ({
  type: Siteactions.GET_PIPELINE_CANDIDATE_CLEAR
});

export const clearGeneralDetails = () => ({
  type: Siteactions.ADD_SITE_GENERAL_DETAILS_CLEAR
});

export const clearSiteGeneralDetails = () => ({
  type: Siteactions.GET_SITE_DETAILS_CLEAR
});

export const getClientCandidateHistory = payload => ({
  type: Siteactions.CANDIDATE_HISTORY,
  payload
});

export const clientCandidateEmail = payload => ({
  type: Siteactions.CANDIDATE_EMAIL_ALL,
  payload
});
